import React from 'react';
import { Route, Redirect } from 'react-router-dom';

import { Auth } from '../support';

const GuardedRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={(props) => (
    Auth.isAuthenticated()
      ? <Component {...props} />
      : <Redirect to={{
          pathname: rest.redirectTo || '/auth/login',
          search: props.search,
          state: {
            from: props.location
          }
        }} />
  )} />
)

export default GuardedRoute;